import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_EMDR_UNSEEN_DOC_COUNT = "GET_EMDR_UNSEEN_DOC_COUNT";

export const service = async (data) => {
  const options: object = {
    url: `/api/admin/GetUnseenDocumentCount`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_EMDR_UNSEEN_DOC_COUNT, service, mock);
